import {CreateKycActions, CreateKycState} from "./types";

export const initialCreateKycState: CreateKycState = {
  currentCreateKycStep: "basicForm",
  basicFormData: {
    address: "",
    businessDescription: "",
    businessName: "",
    country: "",
    dateOfBirth: "1999-01-01",
    emailAddress: "",
    gender: "",
    legalName: "",
    postalCode: "",
    numberCode: "+234",
    phoneNumber: "",
    socialLinks: [{name: "LinkedIn", link: ""}],
  },
  documentUploadFormData: {
    businessRegistration: null,
    confirmAccuracy: false,
    governmentId: null,
    proofOfAddress: null,
    selfieWithId: null,
  },
  kycId: null,
};

export const createKycReducer = (
  state: CreateKycState = initialCreateKycState,
  action: CreateKycActions
) => {
  if (action.type === "update-create-kyc-form-step") {
    return {...state, currentCreateKycStep: action.payload};
  }
  if (action.type === "update-basic-form-data") {
    return {
      ...state,
      basicFormData: action.payload,
    };
  }
  if (action.type === "update-document-upload-form-data") {
    return {
      ...state,
      documentUploadFormData: action.payload,
    };
  }
  if (action.type === "reset-state") {
    const yo = {...initialCreateKycState};
    return yo;
  }
  if (action.type === "update-kyc-id") {
    return {...state, kycId: action.payload};
  }

  return state;
};
